import axios from "axios";
import { getAttribution } from "@/lib/attribution";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SID_KEY = "btk_replay_sid";
const sent = new Set();

function sessionId() {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

function ridFromUrl() {
  const rid = new URLSearchParams(window.location.search).get("rid");
  return rid && rid.length <= 128 ? rid : null;
}

export function sendReplayEvent(eventName, watchPct = null) {
  if (sent.has(eventName)) return; // once per viewer session
  sent.add(eventName);
  axios
    .post(`${API}/replay-event`, {
      session_id: sessionId(),
      rid: ridFromUrl(),
      offer_type: "va-benefit-to-keys",
      event_name: eventName,
      watch_pct: watchPct,
      page_url: window.location.href,
      referrer_url: document.referrer || "",
      attribution: getAttribution(),
      replay_variant: "default",
    })
    .catch(() => {});
}

// Milestones by elapsed watch time (requires confirmed duration); provider-API tracking can replace this later.
export function startMilestoneTimer(durationSeconds) {
  sendReplayEvent("replay_played", 0);
  if (!durationSeconds) return () => {};
  let elapsed = 0;
  const marks = [
    [25, "replay_25"], [50, "replay_50"], [75, "replay_75"], [90, "replay_90"], [99, "replay_completed"],
  ];
  const iv = setInterval(() => {
    if (document.hidden) return;
    elapsed += 5;
    const pct = Math.min(100, (elapsed / durationSeconds) * 100);
    for (const [threshold, name] of marks) {
      if (pct >= threshold) sendReplayEvent(name, Math.round(pct));
    }
    if (pct >= 100) clearInterval(iv);
  }, 5000);
  return () => clearInterval(iv);
}
